import { Component, OnInit , ViewChild,ElementRef  } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, share } from 'rxjs/operators';
import { of } from 'rxjs';
// import { API_TOOL } from 'src/shared/common';
import { API_BASE, API_TOOL } from 'src/shared/common';


@Component({
  selector: 'app-tools-ucodvn',
  templateUrl: './tools-ucod.component.html',
  styleUrls: ['./tools-ucod.component.scss']
})
export class ToolsUcodComponent implements OnInit {

  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  isDragging = false;
  startX = 0;
  scrollLeft = 0;

  startDragging(event: MouseEvent) {
    this.isDragging = true;
    this.startX = event.pageX - this.scrollContainer.nativeElement.offsetLeft;
    this.scrollLeft = this.scrollContainer.nativeElement.scrollLeft;
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    event.preventDefault();
    const x = event.pageX - this.scrollContainer.nativeElement.offsetLeft;
    const walk = (x - this.startX) * 1.5; // Điều chỉnh tốc độ kéo
    this.scrollContainer.nativeElement.scrollLeft = this.scrollLeft - walk;
  }

  stopDragging() {
    this.isDragging = false;
  }
  isActive: boolean = true;

  toggleActive(): void {
    this.isActive = !this.isActive;
  }

  isModalVisible = false;
  currentLanguage: 'vi' | 'en' = 'vi';

  content = {
    vi: {
      title: 'Tiêu đề',
      short: 'Mô tả ngắn',
      version: 'Phiên bản',
      change_lang: 'Thay đổi ngôn ngữ',
      mccd: 'MCCD',
      sex: 'Giới tính',
      age: '9 năm',
      age_unit1: 'Năm',
      partI: 'Phần I',
      partI_desc: 'Mô tả phần I',
      partII: 'Phần II',
      partII_desc: 'Mô tả phần II',
      warning: 'Cảnh báo',
      warning_desc: 'Mô tả cảnh báo',
      btn_run: 'Chạy',
      conclusion: '',
      explanation: ''
    },
    en: {
      title: 'Title',
      short: 'Short Description',
      version: 'Version',
      change_lang: 'Change Language',
      mccd: 'MCCD',
      sex: 'Sex',
      age: '9 years',
      age_unit1: 'Years',
      partI: 'Part I',
      partI_desc: 'Description of Part I',
      partII: 'Part II',
      partII_desc: 'Description of Part II',
      warning: 'Warning',
      warning_desc: 'Description of Warning',
      btn_run: 'Run',
      conclusion: '',
      explanation: ''
    }
  };
  tablesection: any;
  tablerela: any;
  table: any;
  result: any;
  sex: string = '';
  age: string = '';
  ageUnit: string = 'y';
  partI: string = '';
  partII: string = '';
  conclusion: string = this.content.vi.conclusion;
  explanation: string = this.content.vi.explanation;

  diagnosisData: { code: string; name: string; part: string; line: number; note: string }[] = [];

  constructor(private http: HttpClient) {}

  ngOnInit() {}

  updateDiagnosisData() {
    this.diagnosisData = [];
    this.processCodes(this.partI.split('\n'), 'I');
    this.processCodes(this.partII.split(','), 'II');
  }

  private processCodes(codesArray: string[], part: string) {
    codesArray.forEach((code, index) => {
      const trimmedCode = code.trim();
      if (trimmedCode) {
        this.diagnosisData.push({
          code: trimmedCode,
          name: '',
          part,
          line: index + 1,
          note: ''
        });
      }
    });
  }

  onCodesIChange() {
    this.updateDiagnosisData();
    this.onInputchange();
  }

  onCodesIIChange() {
    this.updateDiagnosisData();
    this.onInputchange();
  }

  openModal() {
    this.isModalVisible = true;
  }

  closeModal() {
    this.isModalVisible = false;
  }

  toggleLanguage() {
    this.currentLanguage = this.currentLanguage === 'vi' ? 'en' : 'vi';
    this.updateLanguageContent();
    this.onInputchange();
  }

  updateLanguageContent() {
    this.conclusion = this.content[this.currentLanguage].conclusion;
    this.explanation = this.content[this.currentLanguage].explanation;
  }

  onSubmit() {
    const formData = new FormData();
    let sex = this.sex === 'Nam' ? 'm' : 'f';
    let age = this.age || '9';
    let ageUnit = this.ageUnit === 'Năm' ? 'y' : 'm';

    formData.append('partI', this.partI.trim());
    formData.append('partII', this.partII.trim());
    formData.append('age', age);
    formData.append('ageUnit', ageUnit);
    formData.append('sex', sex);
    formData.append('lang', 'VI');

    const validation = this.isValidInput(formData);
    if (!validation.isValid) {
      alert(validation.messages.join('\n'));
      return;
    }

    this.http.post(API_TOOL, formData).subscribe(
      (response: any) => {
        if (response) {
          this.conclusion = response?.result;
          this.explanation = response?.table;
          this.table = response.log;
          this.tablerela = response.matrix;
          this.tablesection = response.desc;
        }
      },
      (error) => {
        console.error('Error:', error);
        this.handleApiError(error);
      }
    );
  }

  onInputchange() {
    const formData = new FormData();
    let sex = this.sex == 'Nam' ? 'm' : 'f';
    let ageUnit = this.ageUnit === 'Năm' ? 'y' : 'm';

    formData.append('text1', this.partI.trim());
    formData.append('text2', this.partII.trim());
    formData.append('age', this.age + '');
    formData.append('age_unit', ageUnit);
    formData.append('sex', sex);
    formData.append('lang', 'VI');

    this.http.post(`${API_BASE}/api/ucod/liveucod?lang=${this.currentLanguage}`, formData)
    .subscribe(
      (response: any) => {
        if (response) {
          this.conclusion = response?.result;
          this.explanation = response?.table;
          this.table = response.log;
          this.tablerela = response.matrix;
          this.tablesection = response.desc;
        }
      },
      (error: any) => console.error(error)
    );
  }
  
  
  public isValidInput(data: FormData): { isValid: boolean; messages: string[] } {
    const messages: string[] = [];
    const partI = data.get('partI') as string;
    if (!partI || !partI.trim()) {
      messages.push(this.currentLanguage === 'vi' ? 'Phần I không được để trống.' : 'Part I cannot be empty.');
    }
    return { isValid: messages.length === 0, messages };
  }

  private callDiagnoseApi(data: any): Observable<any> {
    const body = new HttpParams()
      .set('partI', data.partI)
      .set('partII', data.partII)
      .set('age', data.age.toString())
      .set('ageUnit', data.ageUnit)
      .set('sex', data.sex)
      .set('lang', this.currentLanguage);

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post<any>(API_TOOL, body.toString(), { headers });
  }

  private handleApiError(error: any) {
    let errorMessage = this.currentLanguage === 'vi' 
      ? 'Có lỗi xảy ra trong quá trình kết nối.' 
      : 'A connection error occurred.';

    if (error?.error?.message) {
      errorMessage = error.error.message;
    } else if (error?.message) {
      errorMessage = error.message;
    }

    alert(errorMessage);
  }
}
